module.exports = __webpack_public_path__ + "img/mars.3ebc0fa4.png";